export class CounterModel {
  source: string;
  code: string;
  type: string;
}
